import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 1265 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1265 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-send\"><defs><style type=\"text/css\"></style></defs><path d=\"M991.962 312.838a346.111 346.111 0 0 0-688.282-6.398A361.109 361.109 0 0 0 361.417 1024h183.958V692.782H294.569L632.39 331.47l337.82 361.313H726.005v331.216h207.452v-1.535a360.904 360.904 0 0 0 58.504-709.626z\" p-id=\"4100\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol